import * as React from 'react';
import TextboxIconImage from './TextboxIconImage';
import ToolIconButton from '../common/ToolIconButton';

interface TextboxToolIconButtonProps {
  readonly buttonNumber: number;
  readonly title?: string;
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly onClick?: () => void;
}

const TextboxToolIconButton: React.SFC<
  TextboxToolIconButtonProps
> = React.memo((props) => {
  const { buttonNumber, title, onClick, style, svgStyle } = props;

  return (
    <ToolIconButton title={title} roundRect={false} onClick={onClick} style={style}>
      <TextboxIconImage buttonNumber={buttonNumber} svgStyle={svgStyle} />
    </ToolIconButton>
  );
});

export default TextboxToolIconButton;
